export default {
  /** Mehrzahl je Sportart für die Überschrift („631 Läufe."). */
  plural: {
    run: 'Läufe',
    ride: 'Radfahrten',
    swim: 'Schwimmeinheiten',
    yoga: 'Yoga-Einheiten',
    strength: 'Krafteinheiten',
    hike: 'Wanderungen',
    walk: 'Spaziergänge',
    other: 'Einheiten',
    all: 'Aktivitäten',
  },
  title: 'Analyse',
  kicker: 'Analyse · {name}',
  pointPerRun: 'Ein Punkt pro Lauf.',
  pointPerUnit: 'Ein Punkt pro Einheit.',
  allSports: 'Alle Sportarten',
  sportGroup: 'Sportart',
  all: 'Alle',
  loadError: 'Konnte nicht laden: {error}',
  noActivities: 'Noch keine Aktivitäten. Nach dem ersten Sync oder FIT-Upload füllt sich die Analyse.',
  noSpeed: 'Für {name} gibt es kein Tempo – Pace-Wolke und Effizienz brauchen eine Sportart mit Geschwindigkeit.',
  noSpeedAll: 'Für alle Sportarten zusammen gibt es kein gemeinsames Tempo – Pace-Wolke und Effizienz gibt es je Sportart.',
  desktopHint: 'Pace-Wolke, Fingerabdrücke und „Was kostet eine Einheit?" gibt es am Desktop',
  trend: 'Trend',
  noHr: 'ohne HF',
  ofN: '{a} von {b}',
  pace: {
    titleRun: 'Jeder Lauf: Pace über Zeit',
    titlePace: 'Jede Einheit: Pace über Zeit',
    titleSpeed: 'Jede Einheit: Tempo über Zeit',
    sub: 'Punktgröße und Deckkraft = Dauer · Farbe = Zone der Ø-Herzfrequenz · Linie = gleitender Trend (±45 Tage)',
    subFaster: ' · schneller ist oben',
    label: 'Pace über Zeit',
    chartLabel: 'Punktwolke von {count} Einheiten',
    chartTrend: '; Trend {trend}',
    empty: 'Keine Einheiten mit Tempo.',
    since: '{from} → {to} {unit} seit {date} – {verdict}',
    same: 'etwa gleich',
    faster: 'schneller',
    slower: 'langsamer',
    takeaway: 'Trend: ',
  },
  eff: {
    title: 'Effizienz-Index',
    sub: 'Meter pro Herzschlag = Ø-Tempo × 60 / Ø-HF · höher ist fitter',
    unit: 'm/Schlag',
    unitName: 'Einheit',
    chartLabel: 'Effizienz über Zeit, {change}',
    empty: 'Keine Einheiten mit Tempo und Herzfrequenz.',
    last90: 'Letzte 90 Tage: ',
    vsYear: ' gegen {prev} vor einem Jahr – {change}',
  },
  load: {
    fitnessSeries: 'Fitness (CTL)',
    fatigueSeries: 'Ermüdung (ATL)',
    formSeries: 'Form (TSB)',
    title: 'Fitness · Ermüdung · Form',
    sub: 'alle Sportarten · CTL 42 Tage, ATL 7 Tage, Form = CTL − ATL · letzte 12 Monate',
    formBig: 'Form {value}',
    chartLabel: 'Fitness, Ermüdung und Form über 12 Monate; Form {form}, {word}',
    races: '; Wettkämpfe: {list}',
    raceItem: '{title} am {date}',
    empty: 'Noch keine Trainingslast.',
    fitness: 'Fitness',
    fatigue: 'Ermüdung',
    form: 'Form',
    race: 'Wettkampf ({count})',
    estimated: {
      one: 'enthält ~{count} geschätzte Last (ohne Herzfrequenz)',
      other: 'enthält ~{count} geschätzte Lasten (ohne Herzfrequenz)',
    },
  },
  cost: {
    title: 'Was kostet eine Einheit?',
    subHrv: 'Tageslast (hrTSS, alle Einheiten des Tages) gegen HRV-Änderung am nächsten Morgen – Folgenacht minus Schnitt der 7 Nächte davor · hohl = geschätzt (~)',
    subRhr: 'Tageslast (hrTSS, alle Einheiten des Tages) gegen Ruhepuls-Änderung am nächsten Morgen – Folgetag minus Schnitt der 7 Tage davor · hohl = geschätzt (~)',
    metric: 'Erholungsmaß',
    hrv: 'HRV',
    rhr: 'Ruhepuls',
    unitHrv: 'ms',
    unitRhr: 'S/min',
    load: 'hrTSS',
    chartLabel: 'Streudiagramm Tageslast gegen {metric}-Änderung am Folgetag für {count} Trainingstage',
    empty: 'Noch keine Trainingstage mit Last und {metric} der Folgenacht.',
    tooltip: '{load} hrTSS · {metric} {delta} {unit} (Folgenacht {next}, Schnitt {base})',
    sessions: { one: '{count} Einheit', other: '{count} Einheiten' },
    trend: 'Trendlinie',
    zone: 'ab ~{threshold} hrTSS',
    tipHrv: 'Ab ~{threshold} hrTSS sinkt die HRV am Folgetag im Schnitt um {value} ms',
    tipRhr: 'Ab ~{threshold} hrTSS steigt der Ruhepuls am Folgetag im Schnitt um {value} S/min',
    noTip: 'Kein deutlicher Effekt: auch nach Tagen ab ~{threshold} hrTSS ändert sich {metric} im Schnitt nur um {value} {unit}',
    days: ' ({count} Tage)',
    rest: '; nach Ruhetagen {value} {unit}.',
    perHundred: ' Trend: {value} {unit} je 100 hrTSS.',
    few: 'Noch zu wenige schwere Tage für eine Aussage.',
  },
  prints: {
    aria: '{sport} {dist} am {date}',
    fadeAria: ', Einbruch in der zweiten Hälfte',
    fade: 'Einbruch 2. Hälfte',
    even: 'gleichmäßig',
    hr: 'HF',
    titleRun: 'Lauf-Fingerabdrücke',
    title: 'Fingerabdrücke',
    lastN: 'letzte 12 {what}',
    recent: 'Long Runs ab {km} km, die letzten 12',
    longest: 'die 12 längsten Läufe – noch keine 12 Long Runs ab {km} km',
    sub: '{which} · Tempo über die Distanz relativ zum eigenen Schnitt (oben = schneller), Fläche = Höhe · rot und „Einbruch" = zweite Hälfte ≥ 4 % langsamer',
    fadeAt: 'Einbruch bei ',
    empty: 'Keine {what} mit Verlauf.',
  },
  z2: {
    title: 'Tempo bei Z2-Puls',
    sub: 'Median-Pace je Woche aus den Laufminuten in Z2 ({band} bpm) · ohne die ersten 10 min, ohne Gehen und Stehen · nur Läufe mit GPS und Wochen ab {min} min · schneller ist oben',
    subNoBand: 'Median-Pace je Woche aus den Laufminuten in Z2 · ohne die ersten 10 min, ohne Gehen und Stehen · schneller ist oben',
    week: 'Woche (Größe = Minuten in Z2)',
    tooltip: 'Woche ab {week}<br/>{pace} /km · {min} min in Z2 · Ø {hr} bpm',
    chartLabel: 'Tempo bei Z2-Puls über {count} Wochen; {trend}',
    empty: 'Noch keine Woche mit mindestens {min} Laufminuten in Z2.',
    noZones: 'Ohne Pulszonen gibt es kein Z2-Band. Zonen stehen in den Einstellungen.',
    last12Short: 'letzte 12 Wochen',
    last12: 'Letzte 12 Wochen ({min} min in Z2): ',
    vsYear: ' gegen {pace} /km ein Jahr davor – {change}',
    faster: '{s} s/km schneller',
    slower: '{s} s/km langsamer',
    same: 'etwa gleich',
  },
  zones: {
    title: 'Zeit in Zonen pro Woche',
    sub: 'letzte 16 Wochen',
    subShare: 'letzte 16 Wochen · {share} % in Z{zone}',
    grey: ' – die „graue Zone"',
    empty: 'Keine Zonenzeiten im Zeitraum.',
    chartLabel: 'Gestapelte Zeit in Herzfrequenzzonen je Woche, {share} Prozent in Zone {zone}',
    barsLabel: 'Zeit in Zonen über 16 Wochen, {share} Prozent in Zone {zone}',
    noVersion: 'keine Zonen-Version im Zeitraum',
    withoutHr: ' · {count} ohne HF',
    version: 'Zonen v{version} · gültig ab {date}',
  },
  cov: {
    title: 'Datenabdeckung',
    sub: 'Monate × Quelle · wo fehlt etwas? · dunkler = vollständiger',
    empty: 'Noch keine Daten.',
    aria: '{label} ({source}): {total} insgesamt, {empty} von {months} Monaten leer',
    days: ' Tage',
  },
  hours: {
    title: 'Stunden pro Monat',
    sub: 'nach Sportart, gestapelt · letzte 12 Monate',
    perMonth: 'pro Monat',
    empty: 'Keine Trainingszeit in den letzten 12 Monaten.',
    chartLabel: 'Gestapelte Balken: Trainingsstunden pro Monat nach Sportart, am meisten im {month} mit {hours} Stunden',
  },
};
